export default () => {
  let activeTriggers = document.querySelectorAll('.js-activeTrigger');

  activeTriggers.forEach(trigger => {
    if (trigger.dataset.bound === 'true') return;

    trigger.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      let dataBody    = trigger.dataset.body_class;
      let focusTarget = trigger.dataset.focus_target;
      let anchor      = trigger.querySelector('a');

      if (anchor) {
        anchor.addEventListener('click', event => {
          event.stopPropagation();
        });
      }

      trigger.classList.remove('js-activeTrigger');

      trigger.classList.toggle('-active');

      if (dataBody) {
        document.body.classList.toggle(dataBody);
      }

      if (focusTarget && trigger.classList.contains('-active')) {
        setTimeout(() => {
          document.querySelector(focusTarget).focus();
        }, 300);
      }
    });

    trigger.dataset.bound = 'true';
  });
}